"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.67,2.81A2.08,2.08,0,0,0,6.59,4.88c0,1.1,1.89,4,2,4.08A.11.11,0,0,0,8.67,9,.11.11,0,0,0,8.77,9c.08-.12,2-3,2-4.08A2.07,2.07,0,0,0,8.67,2.81Zm0,3a.91.91,0,1,1,.9-.9A.9.9,0,0,1,8.67,5.78Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.3,11.3A3.3,3.3,0,0,0,0,14.6c0,1.75,3,6.31,3.13,6.5a.19.19,0,0,0,.17.09.2.2,0,0,0,.17-.09c.13-.19,3.12-4.75,3.12-6.5A3.3,3.3,0,0,0,3.3,11.3ZM3.3,16A1.44,1.44,0,1,1,4.74,14.6,1.45,1.45,0,0,1,3.3,16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.24,7.23A2.77,2.77,0,0,0,18.48,10c0,1.46,2.51,5.28,2.61,5.44a.19.19,0,0,0,.15.08.16.16,0,0,0,.14-.08c.11-.16,2.62-4,2.62-5.44A2.77,2.77,0,0,0,21.24,7.23Zm0,4A1.21,1.21,0,1,1,22.45,10,1.21,1.21,0,0,1,21.24,11.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.55,10.61a.5.5,0,0,1-.26-.08L11.57,7.38a.47.47,0,0,1-.13-.66.48.48,0,0,1,.67-.13l4.71,3.14a.48.48,0,0,1-.27.88Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.65,17.37a.48.48,0,0,1-.44-.28.47.47,0,0,1,.23-.63L17,12a.49.49,0,0,1,.41.88L7.85,17.33A.51.51,0,0,1,7.65,17.37Z"
  }));
};

exports["default"] = _default;